// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const swampert_mega: PokeData = {
  "id": 10064,
  "name": "swampert-mega",
  "height": 19,
  "weight": 1020,
  "base_experience": 286,
  "types": [
    PokeType.WATER,
    PokeType.GROUND
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "growl",
    "water-gun",
    "earthquake",
    "bide",
    "rock-slide",
    "protect",
    "mud-slap",
    "foresight",
    "endeavor",
    "muddy-water",
    "mud-shot",
    "hammer-arm",
    "mud-bomb"
  ],
  "moves": [
    "tackle",
    "growl",
    "earthquake",
    "rock-slide",
    "protect",
    "mud-slap",
    "mud-shot",
    "mud-bomb",
    "water-spout",
    "rain-dance",
    "bonemerang",
    "liquidation",
    "earth-power"
  ],
  "evolution_chain": {
    "id": 132,
    "item": null,
    "species": [
      {
        "name": "mudkip",
        "order": 283,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "marshtomp",
        "order": 284,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 258,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "swampert",
        "order": 285,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 259,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 129,
    "speed": 86,
    "ability_power": 185
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
